module.exports = __webpack_public_path__ + "img/valencia_quatre_carreres.b1a34029.jpg";